import {postRequest} from "./helper"

export const postJobAddApi = (data) => postRequest('add-job',data);
export const jobViewApi = (data) => postRequest('job-view',data);
export const UpdateJobAddApi = (data) => postRequest('update-job',data);
export const JobListApi = (data) => postRequest('job',data);
export const UserJobListApi = (data) => postRequest('job-list',data);
export const companyUSerJobListApi = (data) => postRequest('jobList',data);
export const JobStatusApi = (data) => postRequest('job-change-status',data);


// WEBPACK FOOTER //
// ./src/api/job.js